// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";
import { gaussianPointSplattingScanWGSL } from "./ShadersInclude/gaussianPointSplattingScan";

const name = "gpsScanAddComputeShader";
const shader = `#include<gaussianPointSplattingScan>
@group(0) @binding(0) var<storage,read_write> cdf : array<u32>;@group(0) @binding(1) var<storage,read> blockSums : array<u32>;@compute @workgroup_size(256,1,1)
fn main(@builtin(global_invocation_id) gid : vec3u) {let i=gid.y*65535u*256u+gid.x;if (i>=arrayLength(&cdf)) {return;}
cdf[i]=gpsSaturatingAdd(cdf[i],blockSums[i/512u]);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
const includes = [gaussianPointSplattingScanWGSL];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStoreWGSL[inc.name]) {
        ShaderStore.IncludesShadersStoreWGSL[inc.name] = inc.shader;
    }
}

/** @internal */
export const gpsScanAddComputeShaderWGSL = { name, shader };
